<template>
    <div>
        <div @mouseleave="item.comment_form = false" class="card-footer p-0 bg-light border-0">
            <div v-show="!item.comment_form">
                <!-- heart icon -->
                <span
                    v-if="item.is_heart"
                    class="material-icons pointer text-warning top-botttom-aling"
                    style="font-size:28px;"
                    @click="heart(item.id)"
                >favorite</span>
                <!-- unheart icon -->
                <span
                    v-else
                    class="material-icons pointer text-warning top-botttom-aling"
                    style="font-size:28px;"
                    @click="heart(item.id)"
                >favorite_border</span>

                <!-- count heart -->
                <span class="ml-2" style="font-size:20px;">{{item.heart | numberFormat }}</span>

                <span
                    @click="commentFormToggle(item.id)"
                    class="material-icons text-info float-right pointer mt-2"
                >chat</span>
                <!-- count comment number -->
                <span class="mr-2 float-right top-botttom-aling" style="font-size:20px;">{{item.comments.length | numberFormat}}</span>
            </div>
            <div v-show="item.comment_form">
                <Form
                    v-model="comment"
                    @enter="addComment(item.id);commentFormToggle(item.id);comment = ''"
                    type="text"
                    name="comment"
                    placeholder="Comment"
                    material_icon
                />
                <!-- show comment form -->
                <span
                    @click="commentFormToggle(item.id)"
                    class="material-icons text-info pointer"
                >cancel</span>
                <!-- add comment  -->
                <span
                    @click="addComment(item.id);commentFormToggle(item.id);comment = ''"
                    class="material-icons text-info float-right pointer"
                >near_me</span>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "./../components/Form.vue";
export default {
    name : 'CardFooter',
    data: function() {
        return {
            comment: ""
        };
    },
    props: ["item"],
    methods: {
        heart(id) {
            this.$emit("heart", id);
        },
        commentFormToggle(id) {
            this.$emit("commentFormToggle", id);
        },
        addComment(id) {
            //input
            var comment_value = this.comment;
            //id of item
            var item_id = id;
            //current date
            var date = new Date().toDateString();
            var payload = {
                id: item_id,
                comment_value: comment_value,
                date: date
            };
            comment_value.length > 0 ? this.$emit("addComment", payload) : "";
        },
        alet() {
            alert("com");
        }
    },
    components: {
        Form
    }
};
</script>

<style>
</style>